module.exports = __webpack_public_path__ + "assets/img/cloud5.965c0b84.png";